import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { S_LANG, S_MARKET, webStorage } from "../utils/webStorage";
import { getMarketList, getSiteCountry } from "../services/siteService";

const useChangeMarketModal = ({ fields, cartQtyList, onSubmitForm, onCloseClicked, openModal = false }) => {
  const lang = webStorage.get(S_LANG);
  const params = useParams();
  const [markets, setMarkets] = useState([]);
  const [currentMarket, setCurrentMarket] = useState(null);
  const [showModal, setShowModal] = useState(openModal);
  const { modelHeadingType, modelHeadingBody, modelBody, acceptButton, countryPlaceholder, countryWarningMessage, rejectText, changeMarketButtonText } = fields || {};
  useEffect(() => {
    getMarkets();
  }, [cartQtyList]);
  const getMarkets = async () => {
    const marketList = await getMarketList();
    let current = marketList.find(it => new RegExp(`^${it.language}$`, "gi").test(lang));
    setMarkets(marketList);
    if (!current) {
      const country = await getSiteCountry();
      current = {
        value: country?.name
      };
    }
    setCurrentMarket(current);
  };
  const changeMarket = {
    text: changeMarketButtonText.value || "Change market",
    callback: function(e) {
      e.preventDefault();
      setShowModal(true);
    }
  };
  const changeMarketModalProps = {
    heading: {
      type: modelHeadingType || {
        fields: { phrase: { value: "h1" } }
      },
      html: modelHeadingBody
    },
    body: modelBody.value,
    button: {
      buttonText: acceptButton?.fields.ctaName.value,
      iconName: acceptButton?.fields.iconName
    },
    country: {
      placeholder: countryPlaceholder.value || "Country",
      selectCode: currentMarket ? currentMarket.code : null,
      options: markets,
      enableFilter: true,
      warningMessage: countryWarningMessage.value || "It is mandatory to select a country"
    },
    link: {
      text: rejectText.value,
      callback: evt => setShowModal(false)
    },
    open: showModal,
    disabled: false,
    onSubmitForm: data => {
      onSubmitForm && onSubmitForm(data);
    },
    onCloseClicked() {
      setShowModal(false);
      onCloseClicked && onCloseClicked();
    }
  };
  return {
    markets,
    currentMarket,
    changeMarket,
    changeMarketModalProps,
    getMarkets
  };
};
export default useChangeMarketModal;
